import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { paths } from "../../data/dataSourese";
import { useContext } from "react";
import { DataContex } from "../../context/DataContext";
import { storage } from "../../firebaseConfig/firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { nivelesSuscripcion } from "../../data/suscripcionLevels";

export const MaterialABMForm = ({
  onSubmit,
  submitText,
  description,
  setDescription,
  descargas,
  setDescargas,
  ciclos,
  niveles,
  handleCheckboxChange,
  obraIDs,
  handleObraCheckboxChange,
  tipo,
  setTipo,
  link,
  setLink,
  title,
  setTitle,
  nivelAcceso = 0,
  setNivelAcceso,
  isEditing = false,
}) => {
  const { obrasId, tipoDeMaterial, categoriasRecursosSource } =
    useContext(DataContex);

  const [fileIsReady, setFileIsReady] = useState(false);
  const [currentFileName, setCurrentFileName] = useState("");

  const decodeFileName = (url) => {
    try {
      // Extraer el nombre del archivo de la URL
      const fileName = url.split('/').pop().split('?')[0];
      // Decodificar el nombre del archivo
      const decodedName = decodeURIComponent(fileName);
      // Remover la carpeta si existe (ej: "pdfFile/")
      return decodedName.split('/').pop();
    } catch (error) {
      console.error("Error al decodificar el nombre del archivo:", error);
      return "Archivo sin nombre";
    }
  };

  useEffect(() => {
    if (link === null || link === undefined || link === "") {
      setFileIsReady(false);
      setCurrentFileName("");
    } else {
      setFileIsReady(true);
      setCurrentFileName(decodeFileName(link));
    }
  }, [link]);

  const ordenarArrayPorPropiedad = (array, propiedad) => {
    return array.slice().sort((a, b) => {
      const valorA = a[propiedad].toUpperCase();
      const valorB = b[propiedad].toUpperCase();

      if (valorA < valorB) {
        return -1;
      }
      if (valorA > valorB) {
        return 1;
      }
      return 0;
    });
  };

  function uploadFile(file, fileName, folder) {
    const storageRef = ref(storage, folder + "/" + fileName);
    uploadBytes(storageRef, file)
      .then(async (snapshot) => {
        const downloadURL = await getDownloadURL(snapshot.ref);
        setLink(downloadURL);
      })
      .catch((error) => {
        console.error("Error al cargar el archivo:", error);
      });
  }

  const handleClickFile = () => {
    window.open(link, "_blank");
  };

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      uploadFile(e.target.files[0], description, "/pdfFile/");
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Container>
        <Row className={`mb-3`}>
          <Col md={9}>
            <Form.Group>
              <Form.Label>Descripción</Form.Label>
              <Form.Control
                type="text"
                value={description}
                required
                onChange={(e) => setDescription(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>Descargas</Form.Label>
              <Form.Control
                type="number"
                value={descargas}
                required
                onChange={(e) => setDescargas(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <Form.Group>
          <Form.Label>Nivel de Acceso</Form.Label>
          <Form.Select
            value={nivelAcceso}
            onChange={(e) => setNivelAcceso(Number(e.target.value))}
            required
          >
            {nivelesSuscripcion.map((nivel) => (
              <option key={nivel.id} value={nivel.id}>
                {nivel.nombre}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form.Group>
          <Form.Label>Niveles</Form.Label>
          <Row style={{ padding: "12px" }}>
            {Array.from(ciclos).map((data, id) => (
              <Col key={id} className="mb-3 form-check form-switch">
                <input
                  checked={niveles.includes(`${data}`)}
                  onChange={handleCheckboxChange}
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id={data}
                />
                <label className="form-check-label" htmlFor="inicial">
                  {data}
                </label>
              </Col>
            ))}
          </Row>
        </Form.Group>
        <Form.Group>
          <Row className="mb-5">
            <Col>
              <Form.Label>Tema Relacionado:</Form.Label>
            </Col>
            <Row>
              <Col>
                <Form.Select
                  size="md"
                  value={title}
                  onChange={(e) => {
                    setTitle(e.target.value);
                  }}
                  required
                >
                  <option value="" disabled>Selecciona un Tema</option>
                  {Array.from(
                    ordenarArrayPorPropiedad(
                      categoriasRecursosSource,
                      "temaRelacionado"
                    )
                  ).map((data, id) => (
                    <option key={id} value={data.ID} type="text">
                      {data.temaRelacionado}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              <Col>
                Tema relacionado: <b>{title}</b>
              </Col>
            </Row>
          </Row>
        </Form.Group>
        <Form.Group>
          <Row>
            <Col>
              <Form.Label>Obras asociadas</Form.Label>
              <Row>
                <Col>
                  <div
                    style={{
                      maxHeight: "180px",
                      overflowY: "auto",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "8px 12px",
                    }}
                  >
                    {Array.from(ordenarArrayPorPropiedad(obrasId, "title")).map(
                      (data, id) => (
                        <div key={id} className="form-check form-switch">
                          <input
                            checked={obraIDs.includes(data.ID)}
                            onChange={handleObraCheckboxChange}
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id={data.ID}
                          />
                          <label className="form-check-label" htmlFor={data.ID}>
                            {data.title}
                          </label>
                        </div>
                      )
                    )}
                  </div>
                </Col>
                <Col>
                  Obras ID: <b>{obraIDs.join(", ") || "(ninguna)"}</b>
                </Col>
              </Row>
            </Col>
            <Col>
              <Form.Label>Tipo de material</Form.Label>
              <Row>
                <Col>
                  <Form.Select
                    size="md"
                    value={tipo}
                    onChange={(e) => setTipo(e.target.value)}
                    required
                  >
                    <option value="" disabled>Selecciona un Tipo</option>
                    {Array.from(tipoDeMaterial).map((data, id) => (
                      <option key={id} value={data} type="text">
                        {data}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col>{tipo}</Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Form.Group className="mt-3 mb-3">
              <Form.Control
                type="file"
                onChange={handleFileChange}
                required={!isEditing || !fileIsReady}
                placeholder={currentFileName || "Seleccionar archivo"}
                title={currentFileName || "Seleccionar archivo"}
              />
              {fileIsReady && (
                <>
                  <Row className="mt-3 mb-3" style={{ padding: "12px" }}>
                    <Form.Label><b>Archivo actual: </b>{currentFileName}</Form.Label>
                    <Button onClick={handleClickFile}>Ver Archivo</Button>
                  </Row>
                </>
              )}
            </Form.Group>
          </Row>
        </Form.Group>
        <Row className={`mt-5 mb-5`}>
          <Col>
            <Button type="submit" variant="primary" style={{ width: "100%" }}>
              {submitText}
            </Button>
          </Col>
          <Col>
            <Row>
              <a href={`/${paths.abm}`}>
                <Button style={{ width: "100%" }} variant="danger">
                  Cancelar
                </Button>
              </a>
            </Row>
          </Col>
        </Row>
      </Container>
    </Form>
  );
};
